const getAndroidEscapeUrl = (url: string) => {
  return `intent://${url}#Intent;scheme=http;package=com.android.chrome;end`;
};

export default getAndroidEscapeUrl;
